// extracted by mini-css-extract-plugin
export default {"connector":"flowConnector_connector__GSyVS","arrow":"flowConnector_arrow__JrH4A"};